import validation from '../../../../../../modules/Gull/Framework/validation.js';

const stap5 = {

	init() {

		$(document).ready(function() {
			stap5.verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenChange();
		});

		$('#verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaarden').change(stap5.verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenChange);
		$('#aanrakingPolitieJustitie').change(stap5.verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenChange);
		$('#acceptatieCollectieveOngevallen').change(stap5.verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenChange);

		$('.needValiditeitsverklaringOnNee').change(function() {
			if ($(this).val() == 'nee') {
				$(this).closest('.form-group').addClass('has-warning');

				if (window.app.language == 'en_US') {
					var errorMsg = 'Due to the given answer a validity statement is mandatory';
				}
				$(this).closest('.form-group').find('.error-label').html(errorMsg);
				$(this).unbind('blur');
				$('#validiteitsVerklaringUpload').closest('.form-group').removeClass('d-none');
				validation.addRequired($('#validiteitsVerklaringUpload'));
			} else {
				$(this).closest('.form-group').removeClass('has-error').removeClass('has-warning');
				$(this).closest('.form-group').find('.error-label').html('');
				$(this).blur(validation.checkInputBlur);
				$('#validiteitsVerklaringUpload').closest('.form-group').addClass('d-none');
				validation.removeRequired($('#validiteitsVerklaringUpload'));
			}
		});

		$('#werknemersIngestroomdInWGAOfAfgewezenWGA35Min, #fusiesOvernamesLopendeUitkeringen, #werknemersWiaIngestroomd').change(function() {
			$('#werknemersWiaIngestroomdUpload').closest('.form-group').addClass('d-none');
			validation.removeRequired($('#werknemersWiaIngestroomdUpload'));
			$('#werknemersIngestroomdInWGAOfAfgewezenWGA35Min, #fusiesOvernamesLopendeUitkeringen, #werknemersWiaIngestroomd').each(function() {
				if ($(this).val() == 'ja') {
					$('#werknemersWiaIngestroomdUpload').closest('.form-group').removeClass('d-none');
					validation.addRequired($('#werknemersWiaIngestroomdUpload'));
				}
			});
		});

		$(document).ready(function() {
			$('.needValiditeitsverklaringOnNee').trigger('change');
		});

		// Submits
		$('form[data-validate]').attr('data-validate-onsubmit-disabled', true);
		$('form[data-validate]').submit(async function() {
			let validated = await validation.checkSubmitForm(this);
			if (validated) {
				$('#validatieModal').modal('show');
				$('#validatieModalAkkoord').click(function() {
					$('form[data-validate]').unbind('submit');
					$('form[data-validate]').submit();
				});
			}
			return false;
		});

	},

	verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenChange: function() {
		if ($('#verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaarden').val() == 'ja' || $('#aanrakingPolitieJustitie').val() == 'ja' || $('#acceptatieCollectieveOngevallen').val() == 'nee') {
			$('#verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenToelichting').attr('data-validate', 'required').closest('.form-group').show();
		} else {
			$('#verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenToelichting').attr('data-validate', '').closest('.form-group').hide();
		}
	}

};

export default stap5;
